import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import '../styles/stylesTramitesServicios.css'; 
import AdministrativosSection from '../componentes/AdministrativosSection.jsx';

const Tramites = () => {
  const { hash } = useLocation();
  
  useEffect(() => {
    if (hash) {
      const elem = document.querySelector(hash);
      if (elem) elem.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [hash]);

  return (
    <div className="tramites-page">
    
      {/* Sección Administrativa (Ya es responsive por su propio componente) */}
      <section id="tramitesAdministrativos">
        <AdministrativosSection />
      </section>

      {/* Sección Servicios Públicos (Recolección) */}
      <section className="serviciosPublicos" id="serviciosPublicos">
        <div className="recoleccion-container">
          <h2 className="serviciosPublicos-title">Cronograma de Recolección de Residuos</h2>
          <p className="subtitle">Ayudanos a mantener el pueblo limpio sacando la basura en el día correcto.</p>
          
          <div className="cards-recoleccion">
            {/* Card 1: Orgánicos */}
            <div className="card-residuo organico">
              <div className="icono">🍂</div>
              <h3>Lunes, Miércoles y Viernes</h3>
              <hr />
              <p><strong>Residuos húmedos y orgánicos</strong></p>
              <span className="detalle">Restos de comida, yerba, cáscaras.</span>
            </div>

            {/* Card 2: Reciclables */}
            <div className="card-residuo reciclable">
              <div className="icono">♻️</div>
              <h3>Martes</h3>
              <hr />
              <p><strong>Plásticos y Cartón</strong></p>
              <span className="detalle">Botellas limpias, cajas, papeles.</span>
            </div>

            {/* Card 3: Verdes */}
            <div className="card-residuo verde">
              <div className="icono">🌿</div>
              <h3>Jueves</h3>
              <hr />
              <p><strong>Ramas y Yuyos</strong></p>
              <span className="detalle">Poda de jardín y maleza.</span>
            </div>
          </div>
        </div>
      </section>
      
      <Outlet />
    </div>
  )
}

export default Tramites;